export const POST_GAME_COPY = {
  NAILED_IT: 'You nailed it!',
  NICE_CATCH: 'Nice catch!',
  // A missed guess is not a "loss" — it's just a wrong prediction, so we keep it light.
  NEXT_TIME: 'Better luck next time',
  BADGE_EXACT: 'Exact',
  BADGE_RESULT: 'Result',
  BADGE_MISS: 'Miss',
  POINTS_PENDING: 'Scoring…',
  DISMISS: 'Got it',
} as const;

/**
 * World Cup picks have exactly two positive outcomes: an exact-score hit, or a correct
 * result (right direction). There is no "draw" headline — catching the direction is not a
 * draw, and draw is a challenges concept, not a World Cup one. A miss is not a loss.
 */
export function resolveHeadline(isExactHit: boolean, isCorrectResult: boolean): string {
  if (isExactHit) return POST_GAME_COPY.NAILED_IT;
  if (isCorrectResult) return POST_GAME_COPY.NICE_CATCH;
  return POST_GAME_COPY.NEXT_TIME;
}
